import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const CheckIcon = ({ size = 14, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12l5 5L20 7" />
  </svg>
)
